import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { motion, Variants } from 'framer-motion'
import clsx from 'clsx'

import { useReactions } from '@/src/hooks/room/reactions/useReactions'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

import styles from './RaiseHandButton.module.css'

const buttonVariants: Variants = {
  tap: { scale: 0.9 },
}

export const RaiseHandButton = memo(function MemoRaiseHandButton({
  beforeRaise,
}: {
  beforeRaise?: () => Promise<boolean>
}) {
  const { text_primary_color } = useAppSelector(selectBranding)
  const { t } = useTranslation()
  const { handleRaiseHandToggle, isHandRaised, isUpdatingHand } = useReactions({ apiOnly: true, beforeRaise })

  return (
    <motion.button
      style={{ color: text_primary_color ?? '#fff' }}
      className={clsx(styles.raiseHandBtn, {
        [styles.active]: isHandRaised,
      })}
      onClick={handleRaiseHandToggle}
      disabled={isUpdatingHand}
      transition={{ duration: 0.01 }}
      variants={buttonVariants}
      whileTap="tap"
    >
      <span className={styles.icon}>🖐️</span>
      {isHandRaised ? t('reactions.lowerHand') : t('reactions.raiseHand')}
    </motion.button>
  )
})
